import { render, staticRenderFns } from "./FireOutbreakTooltip.vue?vue&type=template&id=3f89880a"
import script from "./FireOutbreakTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./FireOutbreakTooltip.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports